/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Contract_Valid_UntilInputs */

const cs_form_contract_valid_until = /** @type {(inputs: Form_Contract_Valid_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smlouva platná do`)
};

const en_form_contract_valid_until = /** @type {(inputs: Form_Contract_Valid_UntilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contract valid until`)
};

/**
* | output |
* | --- |
* | "Contract valid until" |
*
* @param {Form_Contract_Valid_UntilInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_contract_valid_until = /** @type {((inputs?: Form_Contract_Valid_UntilInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Contract_Valid_UntilInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_contract_valid_until(inputs)
	return cs_form_contract_valid_until(inputs)
});